import { useSystemStore } from 'src/stores/system'
import schemaLdJson from 'src/seo/schemaLdJson'

export default class extends schemaLdJson {
  constructor($this) {
    super($this)
    this.$this = $this
  }

  get seoData() {
    return this.$this.manufacturer?.seoData
  }

  get name() {
    return this.seoData?.metaTitle
  }

  logo() {
    const systemStore = useSystemStore()
    const imgUrl = systemStore.altW
      ? this.$this.manufacturer?.imageLight || this.$this.manufacturer?.image
      : this.$this.manufacturer?.image
    return {
      '@type': 'ImageObject',
      url: `${this.URL}${imgUrl}`,
      contentUrl: `${this.URL}/img/logo.svg`,
      width: '186',
      height: '73',
    }
  }

  generate() {
    const $this = this.$this

    const json = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      url: `${this.URL}${$this.$route.fullPath}`,
      name: this.name,
      datePublished: this.seoData?.created,
      dateModified: this.seoData?.updated,
      description: this.$this.manufacturer?.seoData?.metaDescription,

      isPartOf: this.isPartOf(),

      primaryImageOfPage: this.logo(),

      publisher: this.publisher(),

      mainEntity: {
        '@type': 'Article',
        name: this.name,
        datePublished: this.seoData?.created,
        dateModified: this.seoData?.updated,
        headline: this.parseHeadline(this.seoData?.seoText),
        author: this.authorCasino(),

        publisher: this.publisher(),
      },

      breadcrumb: this.breadcrumb([
        {
          '@type': 'WebPage',
          '@id': `${this.URL}${$this.$route.fullPath}`,
          name: `👇${this.name}`,
        },
      ]),
    }

    return JSON.stringify(json)
  }
}
